

export class WaybillOrder {
  clinicId: number;
  clinicDescr: string;
  orderId: number;
  printedSw: boolean;
  printedStatus: string;
  orderIdMmd: number;
  patientName: string;
  displayType: string;
  delivererCode: string | null;

  constructor() { }
}


import { PaginationParams } from "./common";

export class DistributionWaybillsSearchParams extends PaginationParams {

  constructor() {
    super();
  }
}

export class DistributionWaybillsResponse {
  waybills: WaybillOrder[] = [];

  constructor() { }
}

export class CreateDeliveryWaybillsResponse {
  printedClinicCnt: number;
  printedOrderCnt: number;
  waybillsPdfUrl: string;

  constructor() { }
}
